import React from 'react';

import { cx } from '@emotion/css';
import { MarqueeView } from '@modules/layout/marquee/MarqueeView';

import styles from './TrustedPartnerView.module.scss';

export const TrustedPartnerView = () => {
  return (
    <section className={styles.trusted_partner}>
      <div className={styles.trusted_card_block}>
        <div className={styles.container}>
          <div className={styles.inner_section}>
            <div className={styles.root}>
              <div className={styles.heading_wrapers}>
                <h1
                  className={cx(
                    styles.site_title,
                    styles.trusted_site_title,
                    styles.h1,
                  )}>
                  Your Trusted Maintenance <br /> Partner for Property Managers
                </h1>
                <p className={cx(styles.heading_wrapers_content, styles.p)}>
                  With over a decade of experience in property management,
                  Qeeper’s founders, James and Jack, developed a deep
                  understanding of the unique challenges faced by property
                  managers. Recognising the need for dependable and efficient
                  service providers, they created Qeeper, a multi-trade
                  maintenance provider specifically designed to meet the demands
                  of property managers.
                </p>
              </div>
            </div>
          </div>
        </div>
        <MarqueeView />
      </div>
    </section>
  );
};
